import { PureComponent } from "react";
import { type RouteComponentProps, withRouter } from "react-router";

import { RelatedItemType } from "commonComponents/entity/relatedItem/RelatedItem.types";
import { getRelatedItemEntityData } from "commonComponents/entity/relatedItem/RelatedItem.utilities";
import { RelatedItemTag } from "commonComponents/entity/relatedItem/RelatedItemTag/RelatedItemTag";
import { type IGridCellRenderProps } from "commonComponents/utilities/Grid/Grid.types";
import {
    GridColumnType,
    type IClientGridColumn,
    type IRelatedItemsResponse,
} from "commonComponents/utilities/Grid/GridContainer.types";

export class RelatedItemsCellInternal extends PureComponent<
    IGridCellRenderProps<IRelatedItemsResponse> & RouteComponentProps
> {
    render() {
        const { cellValue, field } = this.props;
        if (!cellValue) {
            return null;
        }

        const relatedItemTags = Object.entries(cellValue.relatedItemsCounts).map(
            (relatedItemKvp) => {
                return (
                    <div key={relatedItemKvp[0]}>
                        <RelatedItemTag
                            hideEntityTypeLabel
                            data-testid={`${field.full}_${relatedItemKvp}`}
                            itemType={
                                RelatedItemType[relatedItemKvp[0] as keyof typeof RelatedItemType]
                            }
                            subject={`${
                                relatedItemKvp[1] > 1
                                    ? getRelatedItemEntityData(
                                          RelatedItemType[
                                              relatedItemKvp[0] as keyof typeof RelatedItemType
                                          ],
                                      ).namePlural
                                    : getRelatedItemEntityData(
                                          RelatedItemType[
                                              relatedItemKvp[0] as keyof typeof RelatedItemType
                                          ],
                                      ).name
                            } (${relatedItemKvp[1]})`}
                            useMultiTagMargins
                        />
                    </div>
                );
            },
        );
        return <div data-testid={field.full}>{relatedItemTags}</div>;
    }
}

export const RelatedItemsCell = withRouter(RelatedItemsCellInternal);

export const columnRelatedItems: IClientGridColumn<IRelatedItemsResponse> = {
    columnType: GridColumnType.relatedItems,
    Cell: RelatedItemsCell,
};
